import Layout from 'shared/components/layouts/Layout';
import LayoutSection from 'shared/components/layouts/LayoutSection';

Layout.Section = LayoutSection;

export {
  Layout
};
